/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type SiteRoleActions_viewer = {
    readonly id: string;
    readonly role: USER_ROLE;
    readonly moderationScopes: {
        readonly siteIDs: ReadonlyArray<string> | null;
        readonly sites: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
        }> | null;
    } | null;
    readonly " $refType": "SiteRoleActions_viewer";
};
export type SiteRoleActions_viewer$data = SiteRoleActions_viewer;
export type SiteRoleActions_viewer$key = {
    readonly " $data"?: SiteRoleActions_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SiteRoleActions_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SiteRoleActions_viewer",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UserModerationScopes",
                "kind": "LinkedField",
                "name": "moderationScopes",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "siteIDs",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Site",
                        "kind": "LinkedField",
                        "name": "sites",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "User",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '1328f418337610d971ddfb47bcc4a130';
export default node;
